(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ergowave-chair-assembly"] && !Shopify.designMode) return;
  try {
    class ChairAssemblyAddon extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-assembly-toggle]');
      this.variantField = this.querySelector('[data-assembly-variant]');
      this.quantityField = this.querySelector('[data-assembly-quantity]');
      this.total = this.querySelector('[data-assembly-total]');
      this.breakdown = this.querySelector('[data-assembly-breakdown]');
      this.chairAmount = this.querySelector('[data-chair-amount]');
      this.assemblyAmount = this.querySelector('[data-assembly-amount]');
      this.productForm = this.closest('product-form-component');
      this.section = this.closest('.shopify-section');
      this.basePrice = Number(this.dataset.basePrice || 0);
      this.assemblyPrice = Number(this.dataset.assemblyPrice || 0);
      this.currency = this.dataset.currency || 'AUD';

      if (this.variantField) this.variantField.value = this.dataset.assemblyVariantId || '';

      this.handleToggle = this.update.bind(this);
      this.handleQuantity = () => requestAnimationFrame(() => this.update());
      this.handleVariant = (event) => {
        const productId = String(event.detail?.data?.productId || '');
        if (productId && productId !== String(this.dataset.productId || '')) return;

        const nextPrice = Number(event.detail?.resource?.price);
        if (Number.isFinite(nextPrice)) this.basePrice = nextPrice;
        requestAnimationFrame(() => this.update());
      };

      this.checkbox?.addEventListener('change', this.handleToggle);
      this.productForm?.addEventListener('quantity-selector:update', this.handleQuantity);
      this.productForm?.querySelector('input[name="quantity"]')?.addEventListener('change', this.handleQuantity);
      this.section?.addEventListener('variant:update', this.handleVariant);
      this.update();
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.handleToggle);
      this.productForm?.removeEventListener('quantity-selector:update', this.handleQuantity);
      this.productForm?.querySelector('input[name="quantity"]')?.removeEventListener('change', this.handleQuantity);
      this.section?.removeEventListener('variant:update', this.handleVariant);
    }

    get quantity() {
      const value = Number(this.productForm?.querySelector('input[name="quantity"]')?.value || 1);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'code',
      }).format(cents / 100);
    }

    update() {
      const selected = Boolean(this.checkbox?.checked);
      const quantity = this.quantity;
      const chairTotal = this.basePrice * quantity;
      const assemblyTotal = selected ? this.assemblyPrice * quantity : 0;

      if (this.variantField) this.variantField.disabled = !selected;
      if (this.quantityField) {
        this.quantityField.disabled = !selected;
        this.quantityField.value = String(quantity);
      }
      if (this.total) this.total.textContent = this.formatMoney(chairTotal + assemblyTotal);
      if (this.breakdown) this.breakdown.hidden = !selected;
      if (this.chairAmount) this.chairAmount.textContent = this.formatMoney(chairTotal);
      if (this.assemblyAmount) this.assemblyAmount.textContent = this.formatMoney(assemblyTotal);
    }
  }

  if (!customElements.get('chair-assembly-addon')) {
    customElements.define('chair-assembly-addon', ChairAssemblyAddon);
  }
  } catch(e) { console.error(e); }
})();

})();
